<template>
    <div class="practiveitem2-container">
        <div class="practive-toptitle">
            <p>学前安全应急</p>
            <span>综合实训数字资源系统（PC版）</span>
        </div>
        <p class="practive-subtitle">主要内容包括学前儿童的安全事故、突发事件以及应急处理措施等，对教学内容进行仿真还原和实训，解决教学中难以进行角色扮演和情景演练的难题。</p>
        <div class="practive-pics">
            <img :src="require('@/assets/images/index/item8.png')" alt="">
            <img :src="require('@/assets/images/index/item9.png')" alt="">
        </div>
        <p class="pics-tips">用户界面</p>
        <p class="practive-subtitle">三维仿真情景模拟实训任务系统，通过三维场景、实训任务发布、考题、互动学习游戏、交互操作等方式，进行交互式实训任务练习。学生以角色扮演的方式进入，角色之间通过对话、动作交互、任务协作等方式进行情景实训。</p>
        <div class="banquan">© 2021 文泉幼教. 版权所有. 学前安全应急综合实训数字资源系统.</div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            
        }
    },
    created() {},
    mounted() {},
    methods: {
        
    }
}
</script>
<style lang='scss' scoped>
.practiveitem2-container {
    .practive-toptitle {
        height: 72px;
        background: linear-gradient(90deg, #0A56B1 0%, #607FFF 100%);
        border-radius: 8px;
        width: 100%;
        color: #fff;
        padding: 9px 30px;
        box-sizing: border-box;
        &>p {
            font-size: 24px;
            font-weight: 500;
            line-height: 33px;
        }
        &>span {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }
    }
    .practive-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        padding: 30px 26px;
        box-sizing: border-box;
    }
    .practive-pics {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        &>img {
            width: 420px;
        }
    }
    .pics-tips {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin: 15px 0 0;
        text-align: center;
    }
    .pics3 {
        width: 500px;
        text-align: center;
        display: block;
        margin: auto;
    }
    .banquan {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        height: 60px;
        background: #F7F7F7;
        border-radius: 8px;
        padding: 20px 30px;
        box-sizing: border-box;
        margin-bottom: 80px;
    }
}
</style>